import { bootstrapApplication } from '@angular/platform-browser';
import {
  initErrorMonitoring,
  provideAppSplash,
  provideCabinetApp,
  removeAppSplash,
} from '@core-session';
import { PlatformType } from '@data-access';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';

initErrorMonitoring(PlatformType.WebCarrier);

bootstrapApplication(AppComponent, {
  providers: [provideCabinetApp(PlatformType.WebCarrier, routes), provideAppSplash()],
}).catch((err) => {
  removeAppSplash();
  // eslint-disable-next-line @/no-console
  console.error(err);
});
